import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
// import { newApi } from 'base/redux/ctx';
const { REACT_APP_BASE_URL: BASE_URL } = process.env

export const auth_api = createApi({
  reducerPath: 'api_auth',
  tagTypes: ['Login', 'VerifyToken'],
  baseQuery: fetchBaseQuery({
    baseUrl: `${BASE_URL}/api/v1`,
  }),
  endpoints: builder => ({
    login: builder.mutation({
      query: arg => ({
        url: `/login`,
        method: 'POST',
        body: {
          ...arg,
          current_role: 'business',
        },
      }),
    }),
  }),
})

export const { useLoginMutation } = auth_api
